import RelationshipContactInformationContainer from './RelationshipContactInformationContainer';

export default RelationshipContactInformationContainer;